export const ru = {
    "TRIGGER_LISTEN": "Прослушивание триггеров",
    "ASSIST_EMPTY_MSG": "AI-агент прослушивает ваш разговор и готов помочь автоматически, когда будет вызван.",
    "MYBOT_TRIGGET_LISTEN": "В данный момент нет активных задач в Моем Боте",
    "MYBOT_EMTPY_MSG": "Чтобы начать задачу в Моем Боте, перейдите на вкладку поиска и выберите опцию \"Запустить с входными данными агента\" для желаемой задачи.",
    "PROACTIVE_MODE": "Проактивный режим",
    "SETTINGS": "Настройки",
    "HELP_AND_SUPPORT": "Помощь и Поддержка",
    "HELP": "Помощь",
    "LANGUAGE": "Язык",
    "THEME": "Тема",
    "FILE_NAME":"Имя файла",
    "AUTOMATIC": "Автоматически",
    "AUTO_SCROLL_TOOLTIP":"Управляет автоматической прокруткой вкладки «Помощь», моего бота и содержимого вкладки «Транскрипт»",
    "DARK": "Темный",
    "LIGHT": "Светлый",
    "THEME_DESC": "Это будет использовать стандартный режим вашей системы",
    "DOCUMENTATION": "Документация",
    "DOC_DESC": "Посмотрите наши подробные статьи по документации.",
    "FAQ_U": "Часто задаваемые вопросы",
    "FAQ_DESC": "Просмотрите часто задаваемые вопросы о AI-агенте.",
    "KORE_ACADEMY": "Академия Кор",
    "TAB_TEXT":"Вкладки не включены! Пожалуйста, включите хотя бы одну вкладку",
    "KORE_ACA_DESC": "Узнайте больше об AI-агенте через курсы академии.",
    "SEARCH": "Поиск",
    "MY_BOT": "Мой Бот",
    "ASSIST": "Помощь",
    "TRANSCRIPT": "Транскрипция",
    "HISTORY": "История",
    "STARTOVER": "Начать заново",
    "TAP_SEARCH":"Нажмите для поиска",
    "RESTART_INPUTS": "Перезапустить с захваченными входными данными",
    "ASKCUSTOMER": "Спросить клиента",
    "TELLCUSTOMER": "Скажите клиенту",
    "WELCOME_MSG": "Приветственное сообщение",
    "SEND": "Отправить",
    "SENT": "Отправлено",
    "AWAITING": "Ожидание ответа | Введите, чтобы продолжить",
    "OVERRIDE": "Введите, чтобы продолжить",
    "OVERRIDE_FILE": "Прикрепите файл, чтобы продолжить",
    "ACCEPT_RESPONSE": "Ответ принят",
    "AGENT_ENTERED": "Агент вошел",
    "EXPECTED_FORMAT": "Ожидаемый формат",
    "INPUT_VALUES": "Входные значения",
    "RESTART": "Перезапустить",
    "START_OVER": "Начать заново",
    "RESTART_CAPTURE": "Перезапустить с захваченными входными данными",
    "CANCEL": "Отмена",
    "INTERRUPT_DIALOG": "ЗАВЕРШЕНИЕ ЗАДАЧИ ДИАЛОГА",
    "RUN": "ВЫПОЛНИТЬ",
    "RUN_AGENT": "Выполнить с входными данными агента",
    "STEP": "Шаг",
    "DIALOG_TASK": "Задача диалога",
    "FAQ": "Часто задаваемые вопросы",
    "SNIPPET": "Ответы",
    "ARTICLE": "Веб-страницы",
    "FILE": "Файл",
    "SUGGESTED": "Предложено",
    "ALL_DIALOG": "Все задачи диалога",
    "DIALOG_TEXT": "Диалог",
    "INTENT_IDENTIFIED": "Выражение клиента",
    "NOT_WHAT_LOOKING": "Неправильное предложение?",
    "BOT": "Бот",
    "CUSTOMER": "Клиент",
    "YOU": "Вы",
    "TERMINATE_CONV": "Завершить задачу диалога",
    "TERMINATE_CONV_DESC": "Вы уверены, что хотите завершить задачу диалога? AI-агент не сможет больше предложить.",
    "YES_TERMINATE": "Да, завершить",
    "NO_CANCEL": "Нет, отменить",
    "OVERRIDE_CONTINUE": "Продолжить в режиме переопределения",
    "SUMMARY_TEXT": "Резюме",
    "SUBMIT": "Отправить",
    "INTERRUPT_OCCURED": "Произошла ошибка",
    "IDENTIFIED_INTENT": "Определенная цель",
    "INTERRUPT_DESC": "Выполнение этого действия завершит вашу текущую задачу диалога.",
    "ACCEPT_RUN": "Принять и выполнить",
    "RUN_LATER": "Выполнить позже",
    "KNOW_MORE": "Узнать больше",
    "MORE_TEXT": "Больше",
    "LESS_TEXT": "Меньше",
    "VIEW_MORE": "Посмотреть больше",
    "VIEW_LESS": "Посмотреть меньше",
    "SHOW_MORE_FAQ": "Показать больше часто задаваемых вопросов",
    "SHOW_LESS_FAQ": "Показать меньше часто задаваемых вопросов",
    "SHOW_MORE_ARTICLE": "Показать больше веб-страниц",
    "SHOW_LESS_ARTICLE": "Показать меньше веб-страниц",
    "SHOW_MORE_SNIPPET": "Показать больше ответов",
    "SHOW_LESS_SNIPPET": "Показать меньше ответов",
    "SHOW_MORE_FILES": "Показать больше файлов",
    "SHOW_LESS_FILES": "Показать меньше файлов",
    "VIEW_ALL_DIALOG": "Посмотреть все диалоги",
    "VIEW_FEW_DIALOG": "Посмотреть несколько диалогов",
    "HELP_FULL": "Полезно?",
    "THANKYOU": "Спасибо!",
    "EXPAND_MORE": "Развернуть / Больше",
    "CLOSE_TEXT": "Закрыть",
    "STARTED": "Начато",
    "ENDED": "Завершено",
    "VIEW_FULL_ARTICLE": "Посмотреть веб-страницу",
    "VIEW_FULL_FILE": "Посмотреть файл",
    "COPIED": "Скопировано",
    "SENTI_ANALY": "Анализ настроений",
    "WRONG_SUGGESTION": "Неверные предложения",
    "INCORRECT_INTENT": "Неверная цель",
    "ACCIDENTAL_CLICK": "Случайный клик",
    "TIME_TAKING": "Требуется время",
    "OTHER": "Другое",
    "PLAYBOOK_EMPTY_MSG": "Выберите сценарий",
    "PLAYBOOK_EMPTY_DESC": "AI-агент не может загрузить сценарий, так как все доступные сценарии являются динамическими. Нажмите \"Выбрать сценарий\", чтобы получить доступ к сценарию",
    "STAGE": "Этап",
    "PROCEED_TO_CLOSE": "Продолжить к закрытию",
    "RECOMENDED_PLAYBOOK": "РЕКОМЕНДОВАННЫЙ СЦЕНАРИЙ",
    "PRIMARY_SCRIPTS": "ОСНОВНЫЕ СЦЕНАРИИ",
    "DYNAMIC_SCRIPTS": "ДИНАМИЧЕСКИЕ СЦЕНАРИИ",
    "RESUME": "Возобновить",
    "ENABLE_CLOSE": "Нажмите кнопку продолжить закрытие, чтобы активировать этап закрытия",
    "LIST_VIEW": "Просмотр списка",
    "TERMINATE": "Завершить",
    "MINIMIZE": "Свернуть",
    "MAXIMIZE": "Развернуть",
    "NO_SEARCH_RESULT": "Результатов поиска не найдено",
    "SENTIMENT_AWAITING": "Ожидание анализа настроений",
    "POSITIVE": "Положительный",
    "NEGATIVE": "Отрицательный",
    "ASSOCIATED_WORK_NOTES": "Примечания к предыдущим решениям",
    "AGENT_JOINED_CONV": "Агент присоединился к разговору",
    "AUTOSCROLL_ASSIST": "Автопрокрутка содержимого вкладки помощи",
    "FILE_SIZE_MSG": "Размер файла должен составлять до 25 МБ. Пожалуйста, попробуйте снова.",
    "OVERRIDE_BTN": "Заменить",
    "CHOOSE_FILE": "Выберите файл",
    "SUMMARY_ERROR_TEXT": "Извините, но произошла ошибка при создании резюме этого разговора. Пожалуйста, создайте свое собственное резюме.",
    "ASK_A_QUESTION": "Задайте вопрос",
    "COPY": "Копировать",
    "PLAYBOOK": "Плейбук",
    "TELL_US_MORE": "Расскажите нам больше…",
    "THANKS_FEEDBACK": "Спасибо за ваш отзыв",
    "SOMETHING_WRONG": "Что-то пошло не так",
    "CLICK_ERROR_DETAILS": "Нажмите, чтобы увидеть детали ошибки",
    "NO_ACTIVE_PLAYBOOK": "Нет активной плейбука",
    "REPHRASE_QUESTION": "Вы можете переформулировать свой вопрос или спросить что-то другое?",
    "VIEW_FULL_ARTICLE_2": "Просмотреть полную статью",
    "VIEW_FULL_FILE_2": "Просмотреть полный файл",
    "INTERNAL_INFO": "Внутренняя информация",
    "SOURCES": "Источники",
    "CONVERSATION_SUMMARY": "Резюме разговора",
    "WAITING": "Ожидание",
    "WIDGET_DISABLED": "Виджет отключен",
    "AI_SETTINGS_DISABLED": "Настройки ИИ отключены! Пожалуйста, свяжитесь с администратором ИИ",
    "SERVER_CONNECTION_ERROR": "Ошибка подключения к серверу",
    "VIEW": "Просмотр",
    "ATTACHMENT_INPUT": "Ввод вложения",
    "TYPE_SUMMARY": "Введите резюме",
    "BY":"От",
    GENERATE_SUMMARY: "Создать резюме",
    PREV_SUMMARIES: "Ранее созданные резюме",
    DIALOG_WORKFLOWS: "Рабочие процессы диалогов",
    SHOW_ALL_DIALOG: "Показать все задачи диалога",
    SHOW_ALL_DIALOGS: "Показать все диалоги",
    CUSTOM_TAB: "Пользовательская вкладка",
    AGENT_INPUT: "Ввод агента",
    "CUSTOM_EMPTY_MSG" : "Нет активного рабочего процесса",
    "CUSTOM_TAB_DESC" : "Чтобы запустить рабочий процесс, выполните один из элементов списка, расположенного в нижней части экрана.",
    "SUBMIT_OVERALL_FEEDBACK" : "Отправить общее мнение",
    "FEEDBACK_POPUP_SUBTITLE" : "Мнение о виджете и его функциях",
    "FEEDBACK_SATISFIED" : "Удовлетворен",
    "FEEDBACK_UNSATISFIED" : "Неудовлетворен",
    "FEEDBACK_PROVIDE_REASONS" : "Предоставить причины",
    "FEEDBACK_TITLE" : "Мнение",
    "AGENTIC_THINKING" : "Думает",
    "AGENTIC_AGENT_TITLE" : "Агент",
    "AGENTIC_COPILOT_MODE_TITLE" : "Режим Агентного Копиллота",
    "AGENTIC_SENDING_MESSAGE" : "Отправка...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot активно слушает ваш разговор и готов автоматически помочь",
    "AGENTIC_SEARCH_RESULTS" : "Агентные результаты"
}